module.exports = __webpack_public_path__ + "img/GBM1_Mono.Macro.f148d01c.png";